import React from 'react';
import { Badge } from 'shards-react';
import { useTranslation } from 'react-i18next';
import { CONDITION_STATUS } from '../../../constants';
import type { ConditionWithDetailTypeClient } from '../../../types/condition';

interface ConditionStatusProps {
  condition: ConditionWithDetailTypeClient | undefined;
}

const ConditionStatus = ({ condition }: ConditionStatusProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <div id="conditionStatus" className="d-inline-flex align-items-center">
        <span className="mr-2">STATUS:</span>
        <Badge className="mr-1" theme="secondary" outline={condition ? condition.conditionStatus !== CONDITION_STATUS.APPROVED : true} disabled style={{ cursor: 'default' }}>
          {t('condition.status.approved')}
        </Badge>
        <span className="mr-1">&gt;</span>
        <Badge className="mr-1" theme="secondary" outline={condition ? condition.conditionStatus !== CONDITION_STATUS.EDITING : true} disabled style={{ cursor: 'default' }}>
          {t('condition.status.editing')}
        </Badge>
        <span className="mr-1">&gt;</span>
        <Badge className="mr-2" theme="secondary" outline={condition ? condition.conditionStatus !== CONDITION_STATUS.REQUEST : true} disabled style={{ cursor: 'default' }}>
          {t('condition.status.request')}
        </Badge>
      </div>
    </>
  );
};

export default ConditionStatus;
